import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import { withRouter } from "react-router"
import Qs from 'query-string'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import Loading from 'components/Loading'
import Block from 'components/common/Block'
import InboundDetailForm from './InboundDetailForm'
import OrderItemList from 'components/common/OrderItemList'

import {
	getUnpaidInboundOrderInfo,
	orderCreditCardPayment,
	getCoupons,
	updateOrder,
} from '../../actions/asyncOrders'

import {
	cleanAction,
} from 'actions/orders'

class InboundDetail extends Component {
	constructor(props){
		super(props);
		const search = Qs.parse(window.location.search);
		this.orderId = search.orderId || props.location.state
	}


	componentDidMount() {
		this.props.getCoupons('available', 1, 20) // status, page, perPage
		this.props.getUnpaidInboundOrderInfo(this.orderId) 
	}

	componentWillReceiveProps(nextProps) {
		const { updateOrderSucc, updateOrderFail, routeParam } = nextProps
		if (updateOrderSucc && !this.props.updateOrderSucc) {
			this.props.history.push('/member/inbound/comfirm', this.orderId)
		}
		if (updateOrderFail && !this.props.updateOrderFail) {
			alert('update order failed')
		}
		if(routeParam.size > 0){
			this.props.history.push(routeParam.get('path'), this.orderId)
		}
	}

	componentWillUnmount(){
		this.props.cleanAction(['routeParam'])
	}

	goBack = () => {
		this.props.history.push('/member/inbound')
	}

	onSubmit = (query) => {
		this.props.updateOrder(this.orderId, query) // orderId, data
	}

	render() {
		const { t, isLoading, memberInfo, location, coupons,
			orderInfo,
		} = this.props
		return (
			<Grid container className="inbound-detail">
				<Loading isLoading={isLoading} />
				<Grid container>
					<Typography variant="h1">{t('inbound_comfirm')}</Typography>
				</Grid>
				<Grid container spacing={4}>
					<Grid item xs={8}>
						<Block
							title={
								<Grid container alignItems="center">
									<i className="material-icons">arrow_back</i>
									{t('back_to_inbound_list')}
								</Grid>
							}
							onClick={this.goBack}
						>
							<Grid container spacing={2}>
								<OrderItemList
									orderId={this.orderId}
								/>
							</Grid>
						</Block>
					</Grid>
					<Grid item xs={4}>
						<InboundDetailForm
							memberInfo={memberInfo}
							onSubmit={this.onSubmit}
							couponlist={coupons.get('list')}
							orderInfo={orderInfo}
						/>
					</Grid>
				</Grid>
			</Grid>
		)
	}
}

const mapStateToProps = state => ({
	isLoading: state.orders.isLoading,
	orderInfo: state.orders.orderInfo,
	memberInfo: state.member.member,
	updateCreditCardSucc: state.member.updateCreditCardSucc,
	orderItemList: state.orders.orderItemList,
	coupons: state.orders.coupons,
	updateOrderSucc: state.orders.updateOrderSucc,
	updateOrderFail: state.orders.updateOrderFail,
	routeParam: state.orders.routeParam,
})

const mapDispatchToProps = {
	getUnpaidInboundOrderInfo,
	orderCreditCardPayment,
	getCoupons,
	updateOrder,
	cleanAction,
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(withTranslation()(InboundDetail)))
